module.exports = __webpack_public_path__ + "12f1c6410431cb0fcfea09ae87a22cd0.svg";